import { makeStyles } from '@mui/styles';

const useStyles: any = makeStyles((theme: any) => ({
  fieldsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    padding: "20px 0"
  },
  serialRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: "8px"
  },
  fieldStyle: {
    width: "100%",
  },
  sparkButton: {
    marginTop: "8px"
  },
  stateCheckboxes: {
    display: "flex",
    flexWrap: "wrap",
    gap: "4px"
  },
  actionsContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "10px",
    marginTop: "20px"
  },
  actionsRight: {
    display: "flex",
    gap: "10px"
  },
  sharedButtonStyle: {
    width: "120px",
    height: "40px",
    borderRadius: "4px",
    fontFamily: "Roboto",
    fontSize: "16px",
    fontWeight: 500,
    textTransform: "none",
  },
  submitButton: {
    background: theme.gradiants.button,
    color: "#fdfdfe",
  },
  deleteButton: {
    color: theme.palette.error.main,
  }
}));

export default useStyles;
